module.exports = __webpack_public_path__ + "img/iphone-12-pro-blue-hero.e9d730fc.png";